import { InputText } from "./Input";
import { AbstractFormElement, ICustomFormElement } from "./Abstract";

class InputDate extends InputText implements ICustomFormElement {
    protected declare input: HTMLInputElement;
    private _type: string;

    initElements() {
        super.initElements();
        this.type = "date";
        this._type = this.getAttribute("type");
        return this;
    }

    attachEvents() {
        this.addEventListener("click", () => {
            this.input.showPicker();
        });
        this.input.addEventListener(this.mainEvent, () => {
            this.input.classList.toggle("has-value", this.value !== "");
            this.querySelector<HTMLSpanElement>("span.input").dataset.formattedDate = this.formatValue(this.value);
        });
        return super.attachEvents();
    }

    formatValue(v: string) {
        const locale = "de-DE";
        const date = new Date(v);
        const type = this._type;
        if (date.toString() !== "Invalid Date") {
            switch (type) {
                case "month":
                    v = this.formatMonth(date, locale);
                    break;
                default:
                    v = this.formatFullDate(date, locale);
            }
        }
        return v;
    }

    formatFullDate(date: Date, locale: string) {
        return date.toLocaleDateString(locale, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    }

    formatMonth(date: Date, locale: string) {
        return date.toLocaleDateString(locale, {
            year: "numeric",
            month: "2-digit"
        });
    }

    /**
     * validation
     */
    validate() {
        if (this.input.value && this.hasAttribute("allowed-days")) {
            const allowedDays = this.getAttribute("allowed-days")
                .split(",")
                .map((d) => parseInt(d));
            const selectedDay = new Date(this.value).getDay();
            this.input.setCustomValidity("");
            if (!allowedDays.includes(selectedDay)) {
                this.input.setCustomValidity("custom-error");
            }
        }
        const validationResult = super.validate();
        this.input.blur();
        return validationResult;
    }

    get value() {
        return this.input.value;
    }

    set value(v: string) {
        this.input.value = v;
        this.label.classList.toggle("has-value", !!v);
        this.input.classList.toggle("has-value", !!v);
        this.querySelector<HTMLSpanElement>("span.input").dataset.formattedDate = this.formatValue(v);
        this.validate();
    }

    get type() {
        return this.input.getAttribute("type");
    }

    set type(v) {
        this.input.setAttribute("type", "date");
    }
}

InputDate.prototype.shadowStyle = document.createElement("template");
InputDate.prototype.shadowStyle.innerHTML = /*html*/ `
${AbstractFormElement.prototype.shadowStyle.innerHTML}
<style>
input {
    opacity: 0;
}
input::placeholder {
    color: var(--shadow-input-placeholder-color, transparent);;
}
</style>
`;

InputDate.prototype.template = document.createElement("template");
InputDate.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
    <span class="icon calendar" role="presentation"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-date", InputDate);

export { InputDate };
